import { useState } from 'react'

/**
 * BadgesCard
 * Displays user achievement badges and toggles badge instructions.
 */
const BadgesCard = ({ badges = [] }) => {
    const [showDetails, setShowDetails] = useState(false)

    return (
        <>
            <div
                className={`badges-container ${showDetails ? "rounded-top" : "rounded"} p-3 pb-0`}
                style={{ backgroundColor: '#0E3F45' }}
            >
                <div className="text-center mb-2">
                    <h2 className="text-white fs-5 fs-lg-2 fw-semibold mb-1">Your Achievements</h2>
                    <p className="text-white-50 fs-7 fs-lg-5    mb-0"> Your milestones and achievements</p>
                </div>

                <div className="d-flex flex-row g-3 mb-4 justify-content-center">
                    {badges?.map((badge) => (
                        <div key={badge.id} className="w-25 align-items-center me-2">
                            <div className="text-center">
                                <div className='rounded h-50px h-lg-90px text-center pt-3 pt-lg-6' style={{ backgroundColor: '#16313d' }}>
                                    <img src={badge.logo || '/media/images/star-medal5.png'} alt={badge.name} className='img-fluid w-25px w-lg-45px h-35px h-lg-55px' />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="d-flex justify-content-center">
                    <div className="w-60 p-1 px-5 text-white  rounded-top fs-7 cursor-pointer "
                        style={{
                            backgroundColor: '#16313d',
                            borderTopLeftRadius: '40px',
                            borderTopRightRadius: '40px',
                        }}

                        onClick={() => setShowDetails((prev) => !prev)}
                    >
                        <span className='me-2'> View Badges instruction</span>

                        <span className='mt-1'>{showDetails ? <i class="bi bi-caret-up fs-3" /> : <i class="bi bi-caret-down fs-3" />}</span>
                    </div>

                </div>
            </div>
            {
                showDetails && (
                    <div
                        className="p-3 pb-1 rounded-bottom"
                        style={{
                            backgroundColor: "#F2FBFC",
                            borderLeft: "1px solid #9bbfc3",
                            borderRight: "1px solid #9bbfc3",
                            borderBottom: "1px solid #9bbfc3"
                        }}
                    >
                        {badges.map((badge) => (
                            <div key={badge.id} className="d-flex align-items-start mb-2">
                                <img
                                    src={badge.logo || '/media/images/star-medal5.png'}
                                    alt={badge.name}
                                    className="me-2 mt-1"
                                    style={{ width: '20px', height: '25px' }}
                                />
                                <div>
                                    <div className='fs-6 fw-semibold text-uppercase' >{badge?.name}</div>
                                    <p className="mb-1 text-muted small">{badge?.instructions}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }
        </>
    )
}

export default BadgesCard